import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';
import { fetchMe } from './store/slices/authSlice';
import Navbar from './components/layout/Navbar';
import LoginPage from './pages/LoginPage';
import MicrosoftSuccessPage from './pages/MicrosoftSuccessPage';
import IncrementCyclesPage from './pages/IncrementCyclesPage';
import NewIncrementCyclePage from './pages/NewIncrementCyclePage';
import CycleDetailsPage from './pages/CycleDetailsPage';
import HodRecommendationsPage from './pages/HodRecommendationsPage';
import RecommendationsIndexPage from './pages/RecommendationsIndexPage';
import UsersPage from './pages/UsersPage';
import ChangePasswordPage from './pages/ChangePasswordPage';

function PrivateRoute({ children }) {
  const { user, initialized } = useSelector(s => s.auth);
  if (!initialized) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <span className="spinner" style={{ width: 40, height: 40 }} />
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function AppLayout({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Navbar />
      <main style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>{children}</main>
    </div>
  );
}

export default function App() {
  const dispatch = useDispatch();
  const token = localStorage.getItem('access_token');

  useEffect(() => {
    if (token) dispatch(fetchMe());
    else dispatch({ type: 'auth/me/rejected' });
  }, [dispatch, token]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <Routes>
        <Route path="/login"             element={<LoginPage />} />
        <Route path="/microsoft-success" element={<MicrosoftSuccessPage />} />
        <Route path="/*" element={
          <PrivateRoute>
            <AppLayout>
              <Routes>
                <Route path="increment-cycles"          element={<IncrementCyclesPage />} />
                <Route path="increment-cycles/new"      element={<NewIncrementCyclePage />} />
                <Route path="increment-cycles/:id"      element={<CycleDetailsPage />} />
                <Route path="increment-cycles/:id/edit" element={<NewIncrementCyclePage editMode />} />
                <Route path="increment-cycles/:id/hod"  element={<HodRecommendationsPage />} />
                <Route path="recommendations"           element={<RecommendationsIndexPage />} />
                <Route path="recommendations/:id"       element={<HodRecommendationsPage />} />
                <Route path="users"                     element={<UsersPage />} />
                <Route path="change-password"           element={<ChangePasswordPage />} />
                <Route path="*"                         element={<Navigate to="/recommendations" replace />} />
              </Routes>
            </AppLayout>
          </PrivateRoute>
        } />
      </Routes>
    </BrowserRouter>
  );
}
